/**
Adapted from
https://github.com/svecosystem/runed
License MIT
https://github.com/svecosystem/runed/blob/main/LICENSE
*/
import { extract } from '@vpap_svelte/internal';
/**
Watch for changes being made to the DOM tree for an element (or elements)
*/
export function useMutationObserver(target, callback, options = {}) {
    let observer;
    const targets = $derived.by(() => {
        const value = extract(target);
        return new Set(value ? (Array.isArray(value) ? value : [value]) : []);
    });
    const stop = $effect.root(() => {
        $effect(() => {
            if (!targets.size || !window)
                return;
            observer = new window.MutationObserver(callback);
            for (const el of targets)
                observer.observe(el, options);
            return () => {
                observer?.disconnect();
                observer = undefined;
            };
        });
    });
    $effect(() => {
        return stop;
    });
    return {
        stop,
        takeRecords() {
            return observer?.takeRecords();
        },
    };
}
